/*eslint-disable*/
export let redirectUri: string;
export let uri: string;
export let loginUri: string;
export let envHost: string;
export let API_URI: string;
export let baseUriUsers: string;
export let baseUri: string;
export let quesionaireHostUri: string;
export let remote_questionnaire_uri: string;
export let URL_SERVICE_PERSON: string;
export let SERVICE_DOC_GENERATION: string;
export let baseUriTranslate: string;
export let bffDistributorUri: string;
export let document_uri: string;

if (typeof window !== "undefined") {
  if (window.location.hostname === "localhost") {
    bffDistributorUri =
      "https://developv4-distributor.kyc34.com/bff-distributor/v1";
    baseUriUsers = "https://developv4.kyc34.com";
    // baseUriUsers = "http://127.0.0.1:8087"; // to make it work, you need to add this adr in the browser plugin Header editor
    baseUriTranslate = "https://developv4-admin.kyc34.com";
    baseUri = "https://developv4-admin.kyc34.com";
    document_uri = "https://developv4-service-document.kyc34.com";
    uri = "https://developv4.kyc34.com/as/oauth2/token";
    redirectUri = "http://localhost:4002/";
    remote_questionnaire_uri =
      "https://developv4-admin.kyc34.com/components/questionnaire/index_bundle.js";
    API_URI = "https://developv4-admin.kyc34.com/service-person/v1";
    // API_URI = "http://127.0.0.1:8086/service-person/v1";
    loginUri = `https://developv4-login.kyc34.com/?state=kyc34-admin`;
    quesionaireHostUri =
      "https://developv4-admin.kyc34.com/components/questionnaire";
    envHost = "&isLocalhost=true";
    URL_SERVICE_PERSON = "https://developv4.kyc34.com/";
    // URL_SERVICE_PERSON = "http://127.0.0.1:8086/";
    SERVICE_DOC_GENERATION =
      "https://developv4-service-doc-generation.kyc34.com/";
  } else {
    bffDistributorUri =
      "https://developv4-distributor.kyc34.com/bff-distributor/v1";
    baseUriUsers = `https://${window.location.hostname}`;
    baseUriTranslate = `https://${window.location.hostname}`;
    remote_questionnaire_uri = `https://${window.location.hostname}/components/questionnaire/index_bundle.js`;
    baseUri = `https://${window.location.hostname}`;
    document_uri = `https://${window.location.hostname}`;
    uri = `https://${window.location.hostname}/as/oauth2/token`;
    redirectUri = `https://${window.location.hostname}`;
    API_URI = `https://${window.location.hostname}/service-person/v1`;
    loginUri = `https://${window.location.hostname.replace(
      "admin",
      "login"
    )}/?state=kyc34-admin`;
    envHost = "";
    URL_SERVICE_PERSON = `https://${window.location.hostname}/`;
    SERVICE_DOC_GENERATION = `https://${window.location.hostname}/`;
  }
}
